import { doPostFetch } from "./apiFetchHelper";

const apiBase = "/api/sendgrid";

function sendUnsubscribeEmail(email) {
  return doPostFetch(`${apiBase}/unsubscribe`, { email });
}

export default { sendUnsubscribeEmail };
